import React from "react";

const AudioQuestion = ({ question, answer, onAnswer }) => {
  return (
    <div className="space-y-4">
      <h2 className="font-bold text-lg text-gray-800">{question.text}</h2>
      <audio controls src={question.audioUrl} className="w-full" />
      <div className="space-y-2">
        {question.options.map((opt, i) => (
          <div key={i} className="flex items-center gap-2">
            <input
              type="radio"
              name={question._id}
              checked={answer === i}
              onChange={() => onAnswer(i)}
            />
            <label>{opt}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AudioQuestion;
